import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import viewState from './viewState';
import createPersistedState from 'vuex-persistedstate';
import memberAlertStore from '@/member-alerts/MemberAlertStore';
import EventStore from '@/sports-schedule/EventStore';
import SupportFormStore from '@/support-forms/SupportFormStore';
import CommunityCalendarStore from '@/community-calendar/CommunityCalendarStore';
import FormStore from '@/custom-forms/FormStore';
import productsServices from '@/products-and-services/productStore';
import DigitalTVPackagesStore from '@/views/productsAndServices/digital-tv-packages/DigitalTVPackagesStore';
import weatherStore from '@/weather/weatherStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    memberAlertStore,
    user,
    eventStore: EventStore,
    supportFormStore: SupportFormStore,
    communityCalendarStore: CommunityCalendarStore,
    viewState,
    formStore: FormStore,
    productsServices,
    digitalTVPackagesStore: DigitalTVPackagesStore,
    weatherStore
  },
  plugins: [createPersistedState({
    paths: ['user', 'viewState', 'productsServices.customerSelections'],
  })]
});
